
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import ElTableColumnCopy from "@/components/ElTableColumnCopy/index.vue";

import { ElementTableView } from "@/lib/ElementTableView";

import EditCmsCategory from "./components/edit-cmsCategory.vue";
import { CmsCategoryDto } from "@/api/appService";

import { MessageBox } from "element-ui";

@Component({
  name: "CmsCategoryList",
  components: {
    EditCmsCategory,
    ElTableColumnCopy
  }
})
export default class CmsCategoryList extends ElementTableView {
  tableItems: CmsCategoryDto[] = [];

  async created() {
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.cmsCategory
      .getAll({
        keyword: this.queryForm.keyword,
        isActive: this.queryForm.isActive,
        sorting: this.table.sorting,
        from: this.queryForm.from,
        to: this.queryForm.to,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }
  title = "";
  // 新建
  handleCreate() {
    this.$router.push({name:'category-create'});
  }

  // 编辑
  handleEdit(index: number, row: any) {
    this.$router.push({name:'category-edit',params:{id:row.id}});
  }

  // 删除
  async handleDelete(index: number, row: CmsCategoryDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.cmsCategory
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
